import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { messageReducer } from "./message";
import { languageReducer } from "./language";
import { alertReducer } from "./alertReducer";

const reducers = combineReducers({
  authReducer,
  messageReducer,
  languageReducer,
  alertReducer,
});

export default reducers;

export type State = ReturnType<typeof reducers>;
